/**
 * Conversion PDP — stat bars
 *
 * Flips the section to its "visible" state the first time it scrolls into
 * view, which is what starts the dots travelling. All the motion itself is
 * CSS; this only decides when it begins.
 *
 * Scroll-driven CSS (animation-timeline: view()) would do this without script,
 * but it is still Chromium-only, and a stat bar stuck at zero in Safari is
 * worse than a few lines of JavaScript.
 */
class ConversionStats extends HTMLElement {
  connectedCallback() {
    // Without IntersectionObserver, show the finished state rather than
    // leaving every bar empty.
    if (!('IntersectionObserver' in window)) {
      this.dataset.visible = 'true';
      return;
    }

    const replay = this.dataset.replay !== 'false';

    this.observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.intersectionRatio >= 0.35) {
            this.dataset.visible = 'true';
            if (!replay) this.observer.disconnect();
          } else if (replay && entry.intersectionRatio === 0) {
            // Reset only once the section is completely off screen. Resetting
            // while any of it is still visible would show the dots snapping
            // back to zero.
            this.dataset.visible = 'false';
          }
        }
      },
      { threshold: [0, 0.35] }
    );

    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get('conversion-stats')) {
  customElements.define('conversion-stats', ConversionStats);
}
